import { ERegionCode } from '../../../interfaces';

export function getOemHiddenVehicleRegionRules(
  regionCode: ERegionCode,
  vehicleAge: number
) {
  switch (regionCode) {
    case 'TN':
      return vehicleAge < 2 || vehicleAge > 10;
    default:
      return vehicleAge > 10;
  }
}
